import {useState, useEffect, useContext} from "react";
import {UserContext} from "../../context/UserContext";
import {ClientContext} from "../../context/ClientContext";
import {getMasterUsersByClientId} from "../../hooks/User";
import {getClients} from "../../data/clients/repository/ClientsRepository";
import {clientsMock} from "../../mocks/clientsMock";
import {usersMock } from "../../mocks/usersMock";
import {toast} from "react-toastify";
import {messages} from "../../utils/Constants";

export const useUsers = () => {
    const { 
        isCreatedUser, 
        isDeletedUser, 
        isEditedUser,
        clearSuccess,
        setUser 
    } = useContext(UserContext);
    const { 
        setClient
     } = useContext(ClientContext);
    const [users, setUsers] = useState([]);
    const [clients, setClients] = useState([]);
    const [selectedClientId, setSelectedClientdId] = useState(null);
    const [userTableLineId, setUserTableLineId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchClients();
    }, []);

    useEffect(() => {
        if (selectedClientId) {
            fetchUsersByClientId(selectedClientId);
        }
    }, [selectedClientId]);

    useEffect(() => {
        if (isCreatedUser !== null) {
            isCreatedUser
                ? toast.success("Usuário criado com sucesso.")
                : toast.error("Erro ao criar usuário.");
            clearSuccess();
        }
    }, [isCreatedUser]);

    useEffect(() => {
        if (isEditedUser !== null) {
            isEditedUser
                ? toast.success("Usuário editado com sucesso.")
                : toast.error("Erro ao editar usuário.");
            clearSuccess();
        }
    }, [isEditedUser]);

    useEffect(() => {
        if (isDeletedUser !== null) {
            isDeletedUser
                ? toast.success("Usuário excluído com sucesso.")
                : toast.error("Erro ao excluir usuário.");
            clearSuccess();
        }
    }, [isDeletedUser]);

    const fetchClients = async () => {
        try {
            setLoading(true);
            const response = await getClients();
            setClients(response?.clients ?? []);
        } catch (error) {
            //toast.error(messages.loadClientsError);
        } finally {
            setLoading(false);
        }
    };

    const fetchUsersByClientId = async (clientId) => {
        try {
            setLoading(true);
            const response = await getMasterUsersByClientId(clientId);
            if (response) {
                setUsers(response?.data?.users ?? []);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleRowClick = (user) => {
        setUserTableLineId(user.id);
        setUser(user);
    };

    const handleClientChange = (event) => {
        const clientId = event.target.value;
        setSelectedClientdId(clientId);

        const selectedClient = clients.find((client) => String(client.id) === String(clientId));
        setClient(selectedClient);
    };

    const handleUserRole = (role) => {
        switch (role) {
            case "MASTER":
                return "Master/Admin";
            default:
                return "";
        }
    };

    return {
        users,
        clients,
        userTableLineId,
        handleRowClick,
        handleClientChange,
        handleUserRole,
        loading,
    };
};